import { CampaignStateDefinitions } from 'modules/campaignIndex/domainTypes';
import { CampaignPreviewThumbnail } from 'modules/campaigns/lib/components/CampaignPreviewThumbnail';
import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useCount } from 'modules/quickActionsMenu/hooks';
import { SetCount } from 'modules/quickActionsMenu/types';
import { Spinner } from 'ui/spinner';
import { Item } from '../Item';
import { Medium, StyledBadge, StyledThumbnailWrapper } from '../Item/Item.styled';
import { CommandGroup, CommandLoading, EmptyState } from '../Styled';
import { useCampaignSearch } from './useCampaignSearch';

export const CAMPAIGN_SEARCH_TEXT = {
  heading: 'Campaigns',
  emptyStateMessage: 'No matching results',
};

const { emptyStateMessage, heading } = CAMPAIGN_SEARCH_TEXT;

export const CampaignSearch = ({ setCount }: { setCount: SetCount }) => {
  const { debouncedSearchTerm, navigate } = useQuickActionsMenuContext();
  const { info, campaigns, isLoading, thumbnails } = useCampaignSearch(debouncedSearchTerm);
  useCount({ count: info?.count, setCount });

  if (isLoading) {
    return (
      <CommandLoading>
        <Spinner />
      </CommandLoading>
    );
  }

  return (
    <>
      {!campaigns?.length && <EmptyState>{emptyStateMessage}</EmptyState>}

      {campaigns.length > 0 && (
        <CommandGroup heading={heading}>
          {campaigns.map((campaign) => {
            const { campaignState, id, messageMedium, name } = campaign;
            const variant =
              campaignState === CampaignStateDefinitions.Archived
                ? CampaignStateDefinitions.Finished.toLowerCase()
                : campaignState.toLowerCase();

            return (
              <Item
                key={id}
                Icon={
                  <StyledThumbnailWrapper>
                    <CampaignPreviewThumbnail
                      campaign={campaign}
                      previewThumbnail={thumbnails[campaign.templateId]}
                    />
                  </StyledThumbnailWrapper>
                }
                id={id}
                name={name}
                onSelect={() =>
                  navigate({
                    id,
                    path: `/campaigns/${id}?view=Edit`,
                    pageName: 'Campaign details page',
                  })
                }
                suffix={
                  <>
                    <Medium>{messageMedium}</Medium>
                    <StyledBadge variant={variant}>{campaignState}</StyledBadge>
                  </>
                }
                value={`${name} ${id}`}
              />
            );
          })}
        </CommandGroup>
      )}
    </>
  );
};
